import { ActionType } from '../constants/ActionTypes';
import { RoutePath } from '../constants/SitePaths';
import { LocalStorageService } from '../services/LocalStorageService';
import config from '../constants/Configs';
import axios from 'axios';
import { LanguageService } from "../services/LanguageService";
import { updateIntl } from "react-intl-redux";

// User Logout
export const logout = () => ({
  type: ActionType.USER_LOGOUT
});

// User Login 
export const resetLoading = () => ({
  type: ActionType.RESET_LOADING
});

export const loginUserBegin = () => ({
  type: ActionType.LOGIN_USER_BEGIN
});

export const loginUserSuccess = user => ({
  type: ActionType.LOGIN_USER_SUCCESS,
  payload: { user }
});

export const loginUserError = (user, error) => ({
  type: ActionType.LOGIN_USER_FAILURE,
  payload: { error: error, user: user }
});

// User Registration
export const registerUserBegin = () => ({
  type: ActionType.REGISTER_USER_BEGIN
});

export const registerUserSuccess = user => ({
  type: ActionType.REGISTER_USER_SUCCESS,
  payload: { user }
});

export const registerUserError = (error) => ({
  type: ActionType.REGISTER_USER_FAILURE,
  payload: { error }
});

// Save main affiliate and subaffiliate id selected from tree
export const setSubAffiliateId = (data) => ({
  type: ActionType.SUB_AFFILIATE_ID,
  payload: data
});

export const setMainAffiliateId = (data) => ({
  type: ActionType.MAIN_AFFILIATE_ID,
  payload: data
});

// Update user type (main or sub)
export const updateUserType = (data) => ({
  type: ActionType.USER_TYPE,
  payload: data
});

/** User Login */
export function loginUser(data, history) {
  LocalStorageService.remove("authorizationData");

  return dispatch => {
    dispatch(loginUserBegin());
    const params = {
      username: data.username,
      password: data.password,
      grant_type: "password",
      client_secret: '748434cf2eeca18cd7be9661dce8c39d60f16461c8e760426958493b9f79b52f',
      client_id: 8080,
    };
    if (data.captchaCode) {
      params['g-recaptcha-response'] = data.captchaCode;
    }

    //Encode the data
    var body = new URLSearchParams();
    Object.entries(params).forEach(([key, val]) => {
      body.set(key, encodeURI(val));
    });

    return axios({
      method: 'POST',
      url: config.BASE_URL + "/token",
      data: body.toString(),
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      }
    }).then((response) => {
      LocalStorageService.set('authorizationData', response.data);

      LanguageService.setSelectedLanguage(response.data.LanguageId);
      dispatch(updateIntl(LanguageService.getTranslation(response.data.LanguageId)));

      dispatch(setMainAffiliateId(response.data.MainPartnerId));
      dispatch(setSubAffiliateId(response.data.AffiliateId));
      dispatch(updateUserType(response.data.UserType));
      dispatch(loginUserSuccess(response.data));

      return response.data;
    })
      .catch((error) => {
        dispatch(loginUserError(params, error));
      });
  };
}

/* User Registration */
export function registerUser(data, history) {
  return dispatch => {
    dispatch(registerUserBegin());
    const params = {
      Name: data.name,
      Surname: data.surname,
      ReferralId: data.referral_id,
      CompanyName: data.companyName,
      Email: data.email,
      Password: data.password,
      ConfirmPassword: data.confirmPassword,
      PhoneNumber: data.prefix + data.phone,
      CaptchaCode: data.captchaCode,
    };

    return axios({
      method: 'POST',
      url: config.BASE_URL + "/SignUp",
      data: JSON.stringify(params),
      headers: {
        'Content-Type': 'application/json',
      },
    }).then((response) => {
      if (response.status >= 400) {
        // Error
        dispatch(registerUserError(params, response.data));
      } else {
        // Success
        dispatch(registerUserSuccess(params));
        history.push(RoutePath.AFFILIATES);
      }
      return response.data;
    })
      .catch((error) => {
        dispatch(registerUserError())
      });
  };
}

let refreshTokenRequestSent = false;

export function refreshToken(authData, request, Auth) {
  const params = {
    refresh_token: authData.refreshToken,
    grant_type: 'refresh_token',
    client_secret: '748434cf2eeca18cd7be9661dce8c39d60f16461c8e760426958493b9f79b52f',
    client_id: 8080
  };

  //Encode the data
  const body = new URLSearchParams();
  Object.entries(params).forEach(([key, val]) => {
    body.set(key, encodeURI(val));
  });

  if ( authData.isExpired() && !refreshTokenRequestSent) {
    refreshTokenRequestSent = true;
    return axios({
      method: 'POST',
      url: config.BASE_URL + "/token",
      data: body.toString(),
      headers: {
        'grant_type': 'refresh_token',
        'Content-Type': 'application/x-www-form-urlencoded',
      },
    }).then((response) => {
      refreshTokenRequestSent = false;
      if (response.status < 400) {
        LocalStorageService.set('authorizationData', response.data);

        request.headers.Authorization = 'Bearer ' + response.data.access_token;
        return axios(request)
      }
      return response.data;
    })
      .catch((error) => {
        refreshTokenRequestSent = false;
        Auth.invalidateSession();
        window.location.reload();
      });
  } else if (authData.isExpired()) {
      return checkIfRefreshTokenUpdated(authData, request);
  } else {
    refreshTokenRequestSent = false;
    request.headers.Authorization = 'Bearer ' + authData().access_token;
    return axios(request)
  }

  function checkIfRefreshTokenUpdated(authData, request) {
      return new Promise((resolve) => {
          const fixedTimestamp = new Date().getTime();
          const interval = setInterval(() => {
              if (!authData.isExpired()) {
                  clearInterval(interval);
                  return resolve(axios(request));
              } else if (fixedTimestamp + 5000 < new Date().getTime()) { // try to get fresh token during 5 seconds
                  clearInterval(interval);
                  Auth.invalidateSession();
                  window.location.reload();
              }
          }, 1000)
      })

  }
}



// WEBPACK FOOTER //
// ./src/actions/LoginActions.js